import MessageTemplate from './models'

export default MessageTemplate
